import type { SimpleCardConfig } from "./demoHubConfig";

type DemoPersonaSectionProps = {
  personas: SimpleCardConfig[];
};

export function DemoPersonaSection({ personas }: DemoPersonaSectionProps) {
  return (
    <section className="bg-[#f8fafc] py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="font-space-grotesk text-3xl font-bold leading-tight text-slate-950 sm:text-4xl">
            Audience guide
          </h2>
          <p className="mt-4 text-base leading-7 text-slate-600">
            These are not separate demos. They show which teams each demo path is most useful for.
          </p>
        </div>

        <div className="mt-10 grid gap-px border border-slate-200 bg-slate-200 md:grid-cols-2 lg:grid-cols-5">
          {personas.map((persona) => {
            const Icon = persona.icon;
            return (
              <article key={persona.title} className="bg-white p-6">
                <div className="flex h-10 w-10 items-center justify-center border border-slate-200 bg-slate-50 text-slate-800">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <h3 className="mt-6 font-space-grotesk text-xl font-semibold text-slate-950">
                  {persona.title}
                </h3>
                <p className="mt-4 text-sm leading-6 text-slate-600">{persona.value}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
